import $ from "jquery"

export function closeMenu() {
  $('#menu').modal('hide');
  $(document.body).removeClass('modal-open');
  $('.modal-backdrop').remove();
}